import React from 'react';
import styled from 'styled-components';
import { Box } from '../../Box';
import { Button } from '../../Button';
import { IconStrict } from '../../IconStrict';
import { Tooltip } from '../../Tooltip';
import { focusOutlineStyle } from '../../utils/focusOutline';
import { isReactElement } from '../../utils/isReactElement';
import { StyledCell } from './commonComponents';
export const RowActions = ({ rowData, rowActions, isExpanded, toggleExpansion, expandable, canExpandRow, }) => {
    const handleAction = async (e, action) => {
        e.stopPropagation();
        await action(rowData);
    };
    return (React.createElement(StyledCell, { "$stickyCell": Boolean(rowActions) || Boolean(expandable), "$rowActionsBgColor": rowActions?.bgColor },
        React.createElement(Box, { flex: true, alignItems: "center", justifyContent: "flex-end" },
            rowActions?.actions?.map((action, actionIndex) => {
                if (!action.showCondition || action.showCondition(rowData)) {
                    return (React.createElement(Wrapper, { flex: true, key: actionIndex },
                        'element' in action &&
                            isReactElement(action.element) &&
                            React.cloneElement(action.element, {
                                onClick: async (e) => {
                                    await handleAction(e, action.onClick);
                                },
                                tabIndex: 0,
                                className: 'reactElementRowAction',
                            }),
                        !('element' in action) && action.genericButton && (React.createElement(Button, { ...action.genericButton, handleClick: (e) => void handleAction(e, action.onClick) }, action.genericButton.children)),
                        !('element' in action) &&
                            action.iconButton &&
                            (action.iconButton?.tooltipText ? (React.createElement(Tooltip, { content: action.iconButton.tooltipText, position: 'bottom', variant: "bubblegum" },
                                React.createElement(IconStrict, { ...action.iconButton, handleClick: (e) => void handleAction(e, action.onClick) }))) : (React.createElement(IconStrict, { ...action.iconButton, handleClick: (e) => void handleAction(e, action.onClick) })))));
                }
                return null;
            }),
            canExpandRow && (React.createElement(CaretIcon, { render: "caret", handleClick: (e) => {
                    e.stopPropagation();
                    toggleExpansion();
                }, size: 24, "$isOpen": isExpanded, iconColor: isExpanded ? 'cream' : 'liquorice', backgroundColor: isExpanded ? 'liquorice' : 'oatmeal' })))));
};
const Wrapper = styled(Box) `
  white-space: nowrap;
  margin-right: 8px;

  &:last-child {
    margin-right: 0px;
  }

  .reactElementRowAction {
    cursor: pointer;
    ${focusOutlineStyle}
  }
`;
const CaretIcon = styled(IconStrict)(({ $isOpen }) => `
    transform: ${$isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
    transition: transform 0.3s ease;
  `);
//# sourceMappingURL=RowActions.js.map